import React from 'react';
import styled from 'styled-components';
import { StyledInput } from '../../components/StyledInput';
import { StyledDropdown } from '../../components/StyledDropdown';

const Wrapper = styled.div`
	margin: auto;
	margin-top: 5em;
	h4 {
		text-align: center;
	}
`;

const FormContainer = styled.div`
	width: 15em;
	margin: auto;
	max-width: 100%;
	margin-top: 2em;
`;

const HeaderLeft = styled.div`
	text-align: center;
	border: 1px solid #969696;
	height: 2.2em;
	padding: 0.5em 0 0.5em 0;
	float: left;
	clear: none;
	width: 50%;
	display: inline-block;
	margin: 0;
	${(props) => (props.active ? 'border-bottom: none;' : 'border-top: none;')}
`;

const HeaderRight = styled.div`
	height: 2.2em;
	text-align: center;
	border: 1px solid #969696;
	border-left: none;
	${(props) => (props.active ? 'border-bottom: none;' : 'border-top: none;')}
	width: 50%;
	display: inline-block;
	margin: 0;
	padding: 0.5em 0 0.5em 0;
`;

const InputContainer = styled.div`
	margin-top: 2em;
	width: 15em;
	max-width: 100%;
	height: 2.2em;
`;

const ErrorMessage = styled.div`
	color: red;
`;

class SelectMobileNumber extends React.PureComponent {
	//eslint-disable-line
	render() {
		const props = this.props;
		return (
			<Wrapper>
				<h4>Valitse puhelinnumero</h4>
				<FormContainer>
					<HeaderLeft active={props.selectedSubscription.isMnp} onClick={props.switchNumsiOn}>
						<span>Siirrä numero</span>
					</HeaderLeft>
					<HeaderRight active={!props.selectedSubscription.isMnp} onClick={props.switchNumsiOff}>
						<span>Uusi numero</span>
					</HeaderRight>
					{props.selectedSubscription.isMnp && (
						<form name={'mobile-number-input-form'} autoComplete={'off'}>
							<InputContainer>
								Moille siirrettävä puhelinnumero
								<StyledInput onChange={props.onFieldChange} name={'msisdn'} backgroundColor={'#fafafa'} value={props.selectedSubscription.msisdn.value} />
								{props.showErrors && !props.selectedSubscription.msisdn.valid && <ErrorMessage>Tarkista kenttä</ErrorMessage>}
							</InputContainer>
						</form>
					)}
					{!props.selectedSubscription.isMnp && (
						<form name={'mobile-number-input-dropdown'} autoComplete={'off'}>
							<InputContainer>
								<StyledDropdown onChange={props.onFieldChange} title={'Valitse uusi numero'} backgroundColor={'#fafafa'} name={'msisdn'} values={props.freeNumbers} />
							</InputContainer>
						</form>
					)}
				</FormContainer>
			</Wrapper>
		);
	}
}

export default SelectMobileNumber;
